import React from 'react'
import { Button, Box } from '@material-ui/core'
import i18n from 'common/util/internationalization'
import {
    aiGeneratedNotification,
    aiGeneratedNotificationBody,
    aiGeneratedNotificationContent,
    btnDismiss,
    Link
} from '../sectionlist/PregeneratedMinutesStyles'
import { getLocalStorageItem } from 'businesslayer/minutesLocalStore'
import SparkleIcon from 'assets/icons/SparkleIcon'
import { getLearnMoreURL } from 'common/util/urlMap'

interface TtmGeneratedNotificationProps {
    updateTranscriptGeneration: (status: string) => void
    dismissAiNotificationBar: () => void
}

const TtmGeneratedNotification: React.FC<TtmGeneratedNotificationProps> = (props) => {
    const userLanguage = getLocalStorageItem('userLanguage')
    return (
        <Box className={aiGeneratedNotification}>
            <Box className={aiGeneratedNotificationBody}>
                <Box className={aiGeneratedNotificationContent}>
                    <SparkleIcon />
                    <span>
                        {i18n.t('AI_GENERATED_HEADING')}
                        <span style={{ marginLeft: '15px' }}>{i18n.t('AI_INACCURACIES')}</span>{' '}
                        <Link
                            style={{
                                color: '#385F99',
                                fontFeatureSettings: "'liga' off, 'clig' off",
                                fontFamily: 'Source Sans Pro',
                                fontStyle: 'normal',
                                fontWeight: 600,
                                lineHeight: '18px',
                                letterSpacing: 0,
                                textDecoration: 'none'
                            }}
                            href={getLearnMoreURL(userLanguage)}
                            target="blank">
                            {i18n.t('MINUTES_TEMPLATES_LEARN_MORE')}
                        </Link>
                    </span>
                </Box>
                <Button
                    key={'DismissAiGeneratedContentNotification'}
                    className={btnDismiss}
                    onClick={() => {
                        props.dismissAiNotificationBar()
                        props.updateTranscriptGeneration('acknowledged')
                    }}
                    disableFocusRipple
                    disableRipple
                    data-testid="AI_GENERATED_CONTENT_DISMISS_BUTTON"
                    data-analytics="MM-AI-Transcript-Generated-Notification-Dismiss">
                    {i18n.t('TOAST_DISMISS_BUTTON')}
                </Button>
            </Box>
        </Box>
    )
}

export default TtmGeneratedNotification
